export const PASSWORD_SETTINGS_KEY = 'passwordSettings';
